import gql from 'graphql-tag';
import { articleContentFragment } from './article-content.fragment';
import { pollContentFragment } from './poll-content.fragment';
import { lightUserFragment } from './light-user.fragment';

export const echoLightPostFragment = gql`
  fragment echoLightPostFragment on Post {
    Id
    lastEdited
    body
    postType

    deleted

    myPollVote

    links {
      ...linkFragment
    }
    images {
      ...linkFragment
    }

    videos {
      ...linkFragment
    }

    articleContent {
      ...articleContentFragment
    }

    pollContent {
      ...pollContentFragment
    }

    author {
      ...lightUserFragment
    }
  }
  ${articleContentFragment}
  ${pollContentFragment}
  ${lightUserFragment}
`;
